const Urlname = "/order/v1"
export default API => ({
    getCatList(params) {
        return API({ url: `${Urlname}/open/goodsCategory/findAll`,params});
    },
    getEntityCatList({params}) {
        return API({ url: `${Urlname}/open/goodsCategory/getEntityGoodsCategory`,method:'GET',params});
    },
    getEntityGoodsList(data,params) {
        return API({
            url: `${Urlname}/open/entityGoods/list`,
            method:  'POST',
            data,
            params
        })
    },
    getGoodsList(data, params) {
        return API({
            url: `${Urlname}/trainingGoodsMall/findMallGoodsList`,
            method:  'POST',
            params,
            data,
        })
    },
});